import { useQuery } from 'react-query'
import { useParams } from 'react-router-dom'
import FilesAndDirectoriesService from '../../services/FilesAndDirectoriesService'

export const useDirectoryContent = (directoryPath) => {
  const { org, project } = useParams()
  return useQuery<any>({
    queryKey: ['directory-content', org, project, directoryPath],
    queryFn: () => FilesAndDirectoriesService.getDirectoryContents(org!, `${project}/${directoryPath}`),
    enabled: !!org && !!project && !!directoryPath,
  })
}
